import axios from 'axios';

import { serializarProductosAjuste } from '../utils/inventarioCargaSerializer';

export const obtenerListadoCompletoInventario = async () => {
    const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/inventario/listado_completo`);
    return res.data?.productos || [];
};

export const ajustarInventario = async (productos) => {
    const config = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    };

    const campos = serializarProductosAjuste(productos);

    const params = new URLSearchParams();
    Object.keys(campos).forEach((llave) => {
        const valor = campos[llave];
        params.append(llave, valor === null || valor === undefined ? '' : valor);
    });

    const res = await axios.post(
        `${process.env.REACT_APP_API_ROUTE}/inventario/ajustar`,
        params.toString(),
        config
    );

    return res.data;
};
